.<template>
  <div>
    <img src="@/assets/AiIcon.png" class="AI_icon" @click="open()">
    <el-dialog custom-class="AIdialog" title="讯网AI" :visible.sync="dialogFormVisible" width="500px" :close-on-click-modal="false" @close="closeDialog">
      <div class="indexPage page" id="indexPage">
        <!--  -->
        <!-- <div class="questionBox">
          <div class="title">
            <div class="bg"></div>
            <div class="txt b">您是不是想问以下问题</div>
          </div>
          <div class="qList">
            <div v-for="(q, qi) in questions" :key="qi" class="qLi d-flex d-flex-middle" @click="questionFn(q)">
              <span class="b">{{ qi + 1 }}.</span>
              <span>{{ q }}</span>
            </div>
          </div>
        </div> -->
        <!--  -->
        <div class="talkBox">
          <div class="li">
            <div class="aiTxt">
              <img src="@/assets/ai_ai.png" class="icon">
              <div class="txt">
                <div class="name">讯网AI</div>
                <div class="text mb-2">您好,我是讯网AI,很高兴为您服务-您可以这样提问,如: 视频卡顿怎么办</div>
                <div class="text">
                  <p>您是不是想问以下问题:</p>
                  <p class="color cpointer" v-for="(q, qi) in questions" :key="qi" @click="questionFn(q)">{{ q }}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-for="(chatConten, chatConten_index) in finalChat" :key="chatConten_index" class="li">
            <div class="userTxt">
              <div class="txt">
                <!-- <div class="name">{{ getTime() }}</div> -->
                <div class="text">{{ chatConten.user }}</div>
              </div>
              <img src="@/assets/ai_user.png" class="icon">
            </div>
            <div class="aiTxt">
              <img src="@/assets/ai_ai.png" class="icon">
              <div class="txt">
                <div class="name">讯网AI</div>
                <div class="text" v-html="chatConten.ai"></div>
              </div>
            </div>
          </div>
          <div class="li" v-if="loading && aiContentRequest">
            <div class="userTxt">
              <div class="txt">
                <!-- <div class="name">{{ getTime() }}</div> -->
                <div class="text">{{ userInput }}</div>
              </div>
              <img src="@/assets/ai_user.png" class="icon">
            </div>
            <div class="aiTxt">
              <img src="@/assets/ai_ai.png" class="icon">
              <div class="txt">
                <div class="name">讯网AI</div>
                <div class="text" v-html="aiContentRequest"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="" style="width: 100%;height: 6px;" id="_box"></div>
      </div>
      <div slot="footer">
        <div class="bottomBox" @keyup.enter="webSocketSend">
          <div class="inpBox d-flex d-flex-middle d-flex-between">
            <el-input class="mr-1" v-model="userInput" placeholder="请输入" :disabled="loading" clearable></el-input>
            <el-button type="primary" @click="webSocketSend" :disabled="loading">发送</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      wsUrl: "",
      dialogFormVisible: false,
      appId: "873be9d0",
      userInput: "",
      aiContentRequest: "",
      finalChat: [],
      loading: false,
      questions: ['武汉讯网信息技术有限公司的公司简介', '武汉讯网信息技术有限公司产品介绍', '如何联系武汉讯网信息技术有限公司'],
      nowTime: "",
      ttsws: null,
      fileIds: [],

    }
  },
  mounted () {
    this.getIds()
  },
  methods: {
    async getIds() {
      let {code, data, message} = await this.axios.get("/ai/getFileID");
      this.fileIds = data.data || []
    },
    getWebsocketUrl() {
      return new Promise((resolve, reject) => {
        const url = "wss://chatdoc.xfyun.cn/openapi/chat";
        const finalUrl = `${url}?appId=${this.appId}&timestamp=${this.timestamp}&signature=${this.signature}`;
        resolve(finalUrl);
      });
    },
    async getSignature() {
      let {code, data, message} = await this.axios.get("/ai/getSignature.do");
      this.signature = data.data.signature
      this.timestamp = data.data.timestamp
      this.initWebsocket()
    },
    async open () {
        this.nowTime = this.getTime()
        this.dialogFormVisible = true;
        this.questions = ['学习时候视频卡顿怎么办', '为什么突然不能学习', '人脸比对为什么失败了']
    },
    closeDialog () {
      this.finalChat = [];
      this.userInput = "";
      this.aiContentRequest = "";
    },
    getTime () {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let day = now.getDate();
      let hour = now.getHours();
      let minute = now.getMinutes();
      let second = now.getSeconds();
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      hour = hour < 10 ? '0' + hour : hour;
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      let dateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
      return dateTime
    },
    async initWebsocket() {
      let that = this;
      if ('WebSocket' in window) {
        let url = await this.getWebsocketUrl();
        this.ttsws = new WebSocket(url);
        //
        this.ttsws.addEventListener('open', (event) => {
          console.log('WebSocket 已连接')
          this.sendMessage();
        })
        this.ttsws.onerror = (res) => {
          console.log("连接出错" + res)
        }
        this.ttsws.onmessage = (res) => {
          this.result(res.data)
          // console.log("onmessage")
        }
        this.ttsws.onclose = (res) => {
          console.log('WebSocket连接已关闭');
          this.ttsws = null;
        }
      } else {
        this.$message.error('您的浏览器不支持 websocket，请切换到其他浏览器！')
      }
    },
    questionFn (val) {
      this.userInput = val
      this.webSocketSend()
    },
    // 发送
    async webSocketSend() {
      if (this.userInput === '') {
        this.$message.error('内容不可为空')
        return
      }
      this.totalRes = "";
      this.aiContentRequest = "";
      await this.getSignature();
    },
    sendMessage () {
      if (this.userInput === '') {
        this.$message.error('内容不可为空')
        return
      }
      let that = this;
      const params = {
        "chatExtends":{
          "sparkWhenWithoutEmbedding": true
        },
        "fileIds": this.fileIds,
        "messages": [
          {"role": "user", "content": that.userInput}
        ]
      }
      this.ttsws.send(JSON.stringify(params));
      this.loading = true;
      this.scrollBottom()
    },
    requestHandle (requestData) {
      //处理request
      var htmlString = this.aiContentRequest + requestData.content
      var escapedJsString = htmlString.replace(/\n/g,'<br>')

      this.aiContentRequest = escapedJsString;
    },
    // 处理返回消息
    result (resultData) {
      let jsonData = JSON.parse(resultData);
      this.totalRes += resultData;
      //加入到ai回答中
      if (jsonData.status === 1) {
        //不为结束就进行添加
        this.requestHandle(jsonData);
      } else if(jsonData.status === 2) {
        var htmlString = this.aiContentRequest + jsonData.content
        var escapedJsString = htmlString.replace(/\n/g,'<br>')
        if(escapedJsString === undefined || jsonData.code === 66001){
          escapedJsString = 'AI正在努力思考中，请稍等。'
        }
        let contentSomething = {
          sid:jsonData.sid,
          ai: escapedJsString,
          user: this.userInput,
        };
        this.finalChat.push(contentSomething);
        this.userInput = "";
        this.loading = false;
      }
      this.scrollBottom();
      if (jsonData.code === 0 && jsonData.status === 2) {
        this.ttsws.close();
      }
    },
    scrollBottom () {
      this.$nextTick(function () {
        var p = document.getElementById('indexPage');
        p.scrollTop = p.scrollHeight;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.AI_icon {
  width: 80px;
  position: fixed;
  right: 80px;
  bottom: 80px;
  cursor: pointer;
}
// ::v-deep .AIdialog {
//   position: fixed;
//   right: 80px;
//   bottom: 40px;
//   margin: 0 !important;
// }

.indexPage {
  margin: 0 auto;
  padding-bottom: 20px;
  height: 500px;
  overflow-y: auto;

  .talkBox {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;

    .li {
      display: inline-block;
      width: 100%;

      .icon {
        width: 20px;
        height: 20px;
      }

      .userTxt {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;

        .txt {
          max-width: 90%;
          margin: 0 5px;

          .name {
            font-size: 12px;
            color: #999;
            margin-bottom: 5px;
          }

          .text {
            background: #409eff;
            box-sizing: border-box;
            padding: 10px;
            border-radius: 5px;
            color: #fff;
            min-height: 27px;
            line-height: 17px;
            min-width: 20px;
          }
        }
      }

      .aiTxt {
        display: flex;
        align-items: flex-start;
        margin: 10px 0;

        .txt {
          text-align: left;
          max-width: 90%;
          margin: 0 5px;

          .name {
            font-size: 12px;
            color: #999;
            margin-bottom: 5px;
          }

          .text {
            background: #eee;
            box-sizing: border-box;
            padding: 10px;
            border-radius: 5px;
            color: #333;
            line-height: 17px;
          }
        }
      }
    }
  }

  .bottomBox {
    // position: fixed;
    left: 0;
    bottom: 0;
    box-sizing: border-box;

    .inpBox {
      margin: 0 auto;

      .submit {
        width: 44px;
        height: 24px;
        background: #409EFF;
        border-radius: 5px;
        text-align: center;
        color: #fff;
        line-height: 24px;
      }
    }
  }

}

.d-flex {
  display: flex;
  flex-direction: row;
}

.d-flex-between {
  justify-content: space-between;
}

.d-flex-middle {
  align-items: center;
}

.color {
  color: #1F8DFF;
}
</style>
